// 轉派後，簽核流程鏈「印信保管人」節點顯示「實際目前的簽核人」(反映轉派)。
// 只在用印中(pendingStamp) / 待上傳(pendingUpload) 階段生效；其餘階段維持原本(lookup 設定的保管人)。
//
// chain          : 已組好的簽核流程節點陣列，每個節點 { name, type, mail? }；type 含 '申請人' / '上層主管' / '印信保管人'
// stampDetail    : getStampDetail 回傳(res)，需有 stamp_status / next_auditor_mail / next_auditor_name
// stampLookupList: getLookupCodeList('stampType') 回傳(用來把哨兵 'stampOwner' 還原成原保管人姓名)
//
// 規則：把 chain 中的「印信保管人」節點，整批換成目前 next_auditor 名單算出的節點。
// 每個 next_auditor 的顯示名：name 為哨兵 'stampOwner'(尚未轉派) → 用 lookup text2(原保管人姓名)；
// 否則(已轉派) → 直接用 next_auditor_name(被轉派人的姓名)。
const applyReassignToChain = (chain, stampDetail, stampLookupList) => {
  if (!Array.isArray(chain) || !stampDetail) return chain
  const atKeeperStage =
    stampDetail.stamp_status === 'pendingStamp' || stampDetail.stamp_status === 'pendingUpload'
  if (!atKeeperStage) return chain

  const mails = (stampDetail.next_auditor_mail || '').split(',').map((s) => s.trim()).filter(Boolean)
  const names = (stampDetail.next_auditor_name || '').split(',').map((s) => s.trim()).filter(Boolean)
  if (mails.length === 0) return chain

  const keeperNodes = mails.map((mail, i) => {
    let name = names[i]
    if (!name || name === 'stampOwner') {
      const look = (stampLookupList || []).find(
        (o) => (o?.text1 || '').toLowerCase() === mail.toLowerCase()
      )
      name = look ? look.text2 : (name || mail)
    }
    return { name, type: '印信保管人', mail }
  })

  // 保留申請人 / 上層主管節點，只把「印信保管人」節點換成目前實際簽核人
  const head = chain.filter((n) => n?.type !== '印信保管人')
  return [...head, ...keeperNodes]
}

export default applyReassignToChain
